module.exports = __webpack_public_path__ + "img/adorno.690ec4cf.png";